import { merchantMessagesState } from './merchantMessages.state';
import { merchantMessagesActions } from './merchantMessages.actions';
import { merchantMessagesGetters } from './merchantMessages.getters';
import { merchantMessagesMutations } from './merchantMessages.mutations';

export default {
  state: merchantMessagesState,
  actions: merchantMessagesActions,
  getters: merchantMessagesGetters,
  mutations: merchantMessagesMutations,
};
